export default __webpack_public_path__ + "static/media/img3.d7e8dd4a.jpg";